module.exports = __webpack_public_path__ + "img/SC-1799.4b62d43a.png";